import {
  collection,
  doc,
  setDoc,
  getDoc,
  onSnapshot,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

// Get reference to user's task lists document
const getUserDocRef = (userId) => {
  return doc(db, 'users', userId, 'data', 'taskLists');
};

// Save task lists to Firestore
export const saveTaskLists = async (userId, lists) => {
  try {
    const docRef = getUserDocRef(userId);
    await setDoc(docRef, {
      lists,
      updatedAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    console.error('Error saving task lists:', error);
    return { success: false, error };
  }
};

// Load task lists from Firestore
export const loadTaskLists = async (userId) => {
  try {
    const docRef = getUserDocRef(userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, lists: docSnap.data().lists };
    } else {
      // Return default list if no data exists
      const defaultList = {
        id: Date.now(),
        name: 'My Tasks',
        tasks: []
      };
      return { success: true, lists: [defaultList] };
    }
  } catch (error) {
    console.error('Error loading task lists:', error);
    return { success: false, error };
  }
};

// Subscribe to real-time updates
export const subscribeToTaskLists = (userId, callback) => {
  const docRef = getUserDocRef(userId);

  return onSnapshot(docRef, (doc) => {
    if (doc.exists()) {
      callback({ success: true, lists: doc.data().lists });
    } else {
      const defaultList = {
        id: Date.now(),
        name: 'My Tasks',
        tasks: []
      };
      callback({ success: true, lists: [defaultList] });
    }
  }, (error) => {
    console.error('Error subscribing to task lists:', error);
    callback({ success: false, error });
  });
};
